import { render } from "./pantallabarra.vue?vue&type=template&id=6ce05d20&scoped=true"
import script from "./pantallabarra.vue?vue&type=script&lang=js"
export * from "./pantallabarra.vue?vue&type=script&lang=js"

import "./pantallabarra.vue?vue&type=style&index=0&id=6ce05d20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce05d20"]])

export default __exports__